import * as React from "react";
import { Area, AreaWorking } from "../../../entities/Area";
import NumberInput from "../../Inputs/NumberInput";

type Props = {
	maxArea: Area;
	selectedArea: AreaWorking;
	onChange: (area: AreaWorking) => void;
	onBlur: () => void;
	needsFocus: boolean;
	acknowledgeFocusRequest: () => void;
	title: string;
	grid?: number;
	readonly?: boolean;
};

/**
 * A control for editing an area.
 */
export class AreaEditor extends React.PureComponent<Props> {
	private readonly firstInput: React.RefObject<NumberInput>;
	constructor(props: Props) {
		super(props);
		this.firstInput = React.createRef();
	}

	public componentDidMount() {
		if (this.props.needsFocus) {
			this.firstInput.current!.focus();
			this.props.acknowledgeFocusRequest();
		}
	}

	public componentDidUpdate(prevProps: Props) {
		if (!prevProps.needsFocus && this.props.needsFocus) {
			this.firstInput.current!.focus();
			this.props.acknowledgeFocusRequest();
		}
	}

	public handleAreaChange = (
		value: number | null,
		direction: "north" | "south" | "west" | "east"
	) => {
		const area: AreaWorking = {
			...this.props.selectedArea,
			[direction]: value ?? undefined
		};

		this.props.onChange(area);
	};

	public render() {
		const { readonly } = this.props;

		return (
			<div>
				<fieldset>
					<legend className="order__subtitle" aria-label="Area coordinates">
						{this.props.title}
					</legend>
					<div className="map__coordinates">
						<div className="map__coordinate-field">
							<NumberInput
								label="N"
								value={this.props.selectedArea.north}
								onChange={v => this.handleAreaChange(v, "north")}
								min={this.props.maxArea.south}
								max={this.props.maxArea.north}
								step={this.props.grid ?? 0.01}
								onBlur={this.props.onBlur}
								ref={this.firstInput}
								dp={3}
								readOnly={readonly}
							/>
						</div>
						<div className="map__coordinate-field-wrap">
							<div className="map__coordinate-field">
								<NumberInput
									label="W"
									value={this.props.selectedArea.west}
									onChange={v => this.handleAreaChange(v, "west")}
									min={this.props.maxArea.west}
									max={this.props.maxArea.east}
									step={this.props.grid ?? 0.01}
									onBlur={this.props.onBlur}
									dp={3}
									readOnly={readonly}
								/>
							</div>
							<div className="map__coordinate-field">
								<NumberInput
									label="E"
									value={this.props.selectedArea.east}
									onChange={v => this.handleAreaChange(v, "east")}
									min={this.props.maxArea.west}
									max={this.props.maxArea.east}
									step={this.props.grid ?? 0.01}
									onBlur={this.props.onBlur}
									dp={3}
									readOnly={readonly}
								/>
							</div>
						</div>
						<div className="map__coordinate-field">
							<NumberInput
								label="S"
								value={this.props.selectedArea.south}
								onChange={v => this.handleAreaChange(v, "south")}
								min={this.props.maxArea.south}
								max={this.props.maxArea.north}
								step={this.props.grid ?? 0.01}
								onBlur={this.props.onBlur}
								dp={3}
								readOnly={readonly}
							/>
						</div>
					</div>
				</fieldset>
			</div>
		);
	}
}
